import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { SharedModalInfoComponent } from '../../../../../shared/modal-info/modal-info.component';
import { FormGroup } from '@angular/forms';
import { PixKeysService } from '../../keys.service';
import { PixKeyType } from '../../../models/key-type.enum';
import { Auth } from '../../../../../autentication/Auth';
import { AutenticationService } from '../../../../../autentication/autentication.service';
import { EventTypes } from '../../../../../shared/EventTypes';
import { AppEventDispatcher } from '../../../../../utils/AppEventDispatcher';
import { Util } from '../../../../../utils/util';
import { PixKey } from '../../../models/key.model';

@Component({
	selector: 'app-pix-keys-list-assignature',
	templateUrl: './assignature.component.html',
	styleUrls: ['./assignature.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixKeysListAssignatureComponent implements OnInit {

	public submited = false;
	public form: FormGroup;
	public selectedPixKey: PixKey;
	public guid = '';

	constructor(
		private route: ActivatedRoute,
		private pixKeysService: PixKeysService,
		private router: Router,
		public dialog: MatDialog,
		private autenticationService: AutenticationService,
		private pixKeysCreateService: PixKeysService,
	) {}

	ngOnInit() {
		this.selectedPixKey = this.pixKeysCreateService.getPixKey();
		this.guid = Util.generateGUID();
		this.checkParams() ? '' : this.goToList();
	}

	checkParams(): boolean {
		if (!this.selectedPixKey || (this.selectedPixKey.tipoChave !== PixKeyType.EVP && !this.selectedPixKey.codigo)) {
			return false;
		} else {
			return true;
		}
	}

	onSetSignatureForm(form: FormGroup) {
		this.form = form;
	}

	submit(message: boolean) {
		this.submited = message;

		if (this.submited && this.form.valid) {
			this.addAuthToken();
			this.sendAssignature();
		}
	}

	addAuthToken() {
		if (this.form.value.token) {
			Auth.passToken = this.form.value.token;
		}
	}

	addAuthSignature() {
		if (this.form.value.eletronicSignature) {
			Auth.assinaturaEletronica = this.form.value.eletronicSignature;
		}
	}

	sendAssignature() {
		this.autenticationService.sendDigitalSignature(this.form.value.eletronicSignature).subscribe(data => {
			if (data.Sucesso) {
				this.addAuthSignature();
				this.sendRequest();
			}
		}, error => {
			this.handleError(error);
		});
	}

	sendRequest() {
		this.pixKeysCreateService.delete(this.selectedPixKey.codigo, this.selectedPixKey.tipoChave, this.guid).subscribe(data => {
			if (data.Sucesso) {
				this.openModalSuccess();
			}
		}, error => {
			this.handleError(error);
		});
	}

	openModalSuccess() {
		const dialogRef = this.dialog.open(SharedModalInfoComponent, {
			width: '287px',
			data: {
				title: 'Chave excluída com sucesso!',
				topText: this.getTopText(),
				btnName: 'Fechar',
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result) {
				this.router.navigate(['pix/chaves/listar']);
			}
		});
	}

	getTopText(): string {
		switch (this.selectedPixKey.tipoChave) {
			case PixKeyType.CPF:
				return 'CPF: ' + Util.formatCpfCnpj(this.selectedPixKey.codigo);
			case PixKeyType.CNPJ:
				return 'CNPJ: ' + Util.formatCpfCnpj(this.selectedPixKey.codigo);
			case PixKeyType.EMAIL:
				return 'E-mail: ' + this.selectedPixKey.codigo;
			case PixKeyType.PHONE:
				return 'Telefone celular: ' + Util.formatPhone(this.selectedPixKey.codigo);
			case PixKeyType.EVP:
				return 'Chave aleatória: ' + this.selectedPixKey.codigo ;
			case PixKeyType.MANUAL:
				return 'Manual: ' + this.selectedPixKey.codigo ;
		}
	}

	handleError = (error) => AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
	goToList = () => this.router.navigate(['pix/chaves/listar']);
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/keys/list/assignature/assignature.component.ts